import { createTheme } from '@mui/material/styles';

export const colors = {
  // Primary Colors
  primaryMain: '#393996',
  primaryLight1: '#DBDBEC',
  primaryLight2: '#DFDFEE',
  primaryLight3: '#F0F0F7',
  primaryLight4: '#F7F7FB',
  primaryLight5: '#F8F9FD',

  // Action Colors
  actionPurpleDark: '#780078',
  actionPurpleLight: '#4C0099',
  actionGreen: '#006900',
  actionRed: '#963939',

  // Action Light Colors
  actionLightPurple1: '#F2E7F2',
  actionLightPurple2: '#E9E3F0',
  actionLightGreen: '#DBECDB',
  actionLightRed: '#ECDBDB',

  // Gery Colors
  black: '#000000',
  darkGray: '#4D4D4D',
  mediumGray: '#DBDBDB',
  lightGray: '#E6E6E6',
  extraLightGray: '#FAFAFA',
  white: '#FFFFFF',

}
export const typography = {
  fontFamily: 'Google Sans, Arial, sans-serif',

  h1: {
    fontSize: '26px',
    lineHeight: '33px',
    fontWeight: 500, //  26 Med
    letterSpacing: '0%',
  },
  h2: {
    fontSize: '24px',
    lineHeight: '31px',
    fontWeight: 500, // Medium
    letterSpacing: '0%',
  },
  h3: {
    fontSize: '18px',
    lineHeight: '23px',
    fontWeight: 700, // Bold
    letterSpacing: '-1%',
  },
  h4: {
    fontSize: '18px',
    lineHeight: '23px',
    fontWeight: 400, //  18 Reg
    letterSpacing: '0%',
  },
  h5: {
    fontSize: '17px',
    lineHeight: '22px',
    fontWeight: 500, //17 Med
    letterSpacing: '0%',
  },
  h6: {
    fontSize: '17px',  //17 Med 
    lineHeight: '27px',
    fontWeight: 500, // Medium
    letterSpacing: '0%',
  },
  body1: {                 //Normal With Regular
    fontSize: '17px',
    lineHeight: '22px',
    fontWeight: 400, // 17 Reg
    letterSpacing: '0%',
  },
  body2: {                  //Normal with Bold
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 700, // Bold
    letterSpacing: '0%',
  },
  small: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 500, // 16 Med
    letterSpacing: '0%',
  },
  smallRegular: {        //16 Reg
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 400, // Regular
    letterSpacing: '0%',
  },
};

export const mobileTypography = {
  fontFamily: 'Google Sans, Arial, sans-serif',
  h1: {
    fontSize: '20px',
    lineHeight: '25px',
    fontWeight: 500, //  20 Med
    letterSpacing: '0%',
  },
  h2: {
    fontSize: '18px',
    lineHeight: '22.9px',
    fontWeight: 500, // 18 Med
    letterSpacing: '0%',
  },
  h3: {
    fontSize: '16px',
    lineHeight: '20.4px',
    fontWeight: 500, // 16 Med
    letterSpacing: '0%',
  },
  h4: {
    fontSize: '15px',
    lineHeight: '19.1px',
    fontWeight: 700, //  15 Bold
    letterSpacing: '-1%',
  },
  h5: {
    fontSize: '15px',
    lineHeight: '19.1px',
    fontWeight: 500, //15 Med
    letterSpacing: '0%',
  },
  h6: {
    fontSize: '14px',
    lineHeight: '17.8px',
    fontWeight: 500, // 14 Med
    letterSpacing: '0%',
  },
  body1: {
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 500, // 14 Med Para
    letterSpacing: '0%',
  },
  body2: {                  //14 Reg
    fontSize: '14px',
    lineHeight: '17.8px',
    fontWeight: 400, // Bold
    letterSpacing: '0%',
  },
  small: {
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 400, // 14 Reg Para
    letterSpacing: '0%',
  },
  smallRegular: {        //13 Reg
    fontSize: '13px',
    lineHeight: '16.5px',
    fontWeight: 400, // Regular
    letterSpacing: '0%',
  },

}

export const shadows = [
  'none', // Index 0
  '0px 0px 26px 0px #00000008', // 1 - Normal Shadow  
  '4px 0px 20px 0px #00000005', // 2 - Normal X Shadow
  '0px 4px 20px 0px #00000005', // 3 - Normal Y Shadow           
  '0px 0px 40px 0px #00000029', // 4 - Big Shadow
  '0px 3px 5px -1px rgba(0,0,0,0.06), 0px 5px 8px 0px rgba(0,0,0,0.04), 0px 1px 14px 0px rgba(0,0,0,0.03)', // 5
  '0px 3px 5px -1px rgba(0,0,0,0.06), 0px 6px 10px 0px rgba(0,0,0,0.04), 0px 1px 18px 0px rgba(0,0,0,0.03)', // 6
  '0px 4px 5px -2px rgba(0,0,0,0.06), 0px 7px 10px 1px rgba(0,0,0,0.04), 0px 2px 16px 1px rgba(0,0,0,0.03)', // 7
  '0px 5px 5px -3px rgba(0,0,0,0.06), 0px 8px 10px 1px rgba(0,0,0,0.04), 0px 3px 14px 2px rgba(0,0,0,0.03)', // 8
  '0px 5px 6px -3px rgba(0,0,0,0.06), 0px 9px 12px 1px rgba(0,0,0,0.04), 0px 3px 16px 2px rgba(0,0,0,0.03)', // 9
  '0px 6px 6px -3px rgba(0,0,0,0.06), 0px 10px 14px 1px rgba(0,0,0,0.04), 0px 4px 18px 3px rgba(0,0,0,0.03)', // 10
  '0px 6px 7px -4px rgba(0,0,0,0.06), 0px 11px 15px 1px rgba(0,0,0,0.04), 0px 4px 20px 3px rgba(0,0,0,0.03)', // 11
  '0px 7px 8px -4px rgba(0,0,0,0.06), 0px 12px 17px 2px rgba(0,0,0,0.04), 0px 5px 22px 4px rgba(0,0,0,0.03)', // 12
  '0px 7px 8px -4px rgba(0,0,0,0.06), 0px 13px 19px 2px rgba(0,0,0,0.04), 0px 5px 24px 4px rgba(0,0,0,0.03)', // 13
  '0px 7px 9px -4px rgba(0,0,0,0.06), 0px 14px 21px 2px rgba(0,0,0,0.04), 0px 5px 26px 4px rgba(0,0,0,0.03)', // 14
  '0px 8px 9px -5px rgba(0,0,0,0.06), 0px 15px 22px 2px rgba(0,0,0,0.04), 0px 6px 28px 5px rgba(0,0,0,0.03)', // 15
  '0px 8px 10px -5px rgba(0,0,0,0.06), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.03)', // 16
  '0px 8px 11px -5px rgba(0,0,0,0.06), 0px 17px 26px 2px rgba(0,0,0,0.04), 0px 6px 32px 5px rgba(0,0,0,0.03)', // 17
  '0px 9px 11px -5px rgba(0,0,0,0.06), 0px 18px 28px 2px rgba(0,0,0,0.04), 0px 7px 34px 6px rgba(0,0,0,0.03)', // 18
  '0px 9px 12px -6px rgba(0,0,0,0.06), 0px 19px 29px 2px rgba(0,0,0,0.04), 0px 7px 36px 6px rgba(0,0,0,0.03)', // 19
  '0px 10px 13px -6px rgba(0,0,0,0.06), 0px 20px 31px 3px rgba(0,0,0,0.04), 0px 8px 38px 7px rgba(0,0,0,0.03)', // 20
  '0px 10px 13px -6px rgba(0,0,0,0.06), 0px 21px 33px 3px rgba(0,0,0,0.04), 0px 8px 40px 7px rgba(0,0,0,0.03)', // 21
  '0px 10px 14px -6px rgba(0,0,0,0.06), 0px 22px 35px 3px rgba(0,0,0,0.04), 0px 8px 42px 7px rgba(0,0,0,0.03)', // 22
  '0px 11px 14px -7px rgba(0,0,0,0.06), 0px 23px 36px 3px rgba(0,0,0,0.04), 0px 9px 44px 8px rgba(0,0,0,0.03)', // 23
  '0px 11px 15px -7px rgba(0,0,0,0.06), 0px 24px 38px 3px rgba(0,0,0,0.04), 0px 9px 46px 8px rgba(0,0,0,0.03)', // 24
];
export const palette = {
  type: 'light',
  primary: {
    main: colors.primaryMain,
    light1: colors.primaryLight1,
    light2: colors.primaryLight2,
    light3: colors.primaryLight3,
    light4: colors.primaryLight4,
    light5: colors.primaryLight5,
  },
  action: {
    purpleDark: colors.actionPurpleDark,
    purpleLight: colors.actionPurpleLight,
    green: colors.actionGreen,
    red: colors.actionRed,
  },

  actionLight: {
    purple1: colors.actionLightPurple1,
    purple2: colors.actionLightPurple2,
    green: colors.actionLightGreen,
    red: colors.actionLightRed,
  },
  gery: {
    black: colors.black,
    darkGray: colors.darkGray,
    mediumGray: colors.mediumGray,
    lightGray: colors.lightGray,
    extraLightGray: colors.extraLightGray,
    white: colors.white,
  },
  text: {
    primary: colors.black,
    secondary: colors.darkGray,
  },
  background: {
    default: colors.extraLightGray,
  },
};

export const breakPoints = {

  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
  xxs: 443,

};


export const components = {
  MuiCssBaseline: {
    styleOverrides: `
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(57, 57, 150, 0.2); 
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: rgba(57, 57, 150, 0.4); 
      }
      html {
        scroll-behavior: smooth;
      }
    `,
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease',
        '&.Mui-focused': {
          boxShadow: '0 0 0 4px rgba(57, 57, 150, 0.12)',
          transform: 'scale(1.01)',
        },
      },
    }
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(57, 57, 150, 0.04) !important',
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 12px rgba(0,0,0,0.06)',
          zIndex: 10,
          position: 'relative'
        }
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
        '&:hover': {
          backgroundColor: 'rgba(57, 57, 150, 0.03) !important',
          transform: 'translateX(4px)',
        }
      }
    }
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) !important',
        '&.Mui-checked': {
          transform: 'translateX(16px)',
        }
      },
      thumb: {
        transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
        width: 20,
        height: 20,
        '&:hover': {
          transform: 'scale(1.15)',
        }
      }
    }
  }
};

export const overrides = {};

const theme = createTheme({
  palette,
  typography,
  mobileTypography,
  components,
  overrides,
  shadows,
  breakpoints: {
    values: breakPoints,
  },

});

export default theme;

export const drawerWidth = 280;
